var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03711 13.3105C10.3508 13.3105 13.0371 10.6243 13.0371 7.31055C13.0371 3.99684 10.3508 1.31055 7.03711 1.31055C3.7234 1.31055 1.03711 3.99684 1.03711 7.31055C1.03711 10.6243 3.7234 13.3105 7.03711 13.3105Z",
    fill: "#F32A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03711 10.6372V10.6439M7.03711 3.97721V8.64388M13.0371 7.31055C13.0371 10.6243 10.3508 13.3105 7.03711 13.3105C3.7234 13.3105 1.03711 10.6243 1.03711 7.31055C1.03711 3.99684 3.7234 1.31055 7.03711 1.31055C10.3508 1.31055 13.0371 3.99684 13.0371 7.31055Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkError);
export default __webpack_public_path__ + "static/media/linkError.53732289c0a79b6af356086b13941489.svg";
export { ForwardRef as ReactComponent };